/**
 * Legacy-Redirect: /hosts → /people — People-Merge (v2-Relaunch)
 *
 * SPEC.md Global decisions (2026-09-01): "Routes /contacts/* and /hosts/*
 * 301 → /people/*". Die Standortgeber-Liste ist Teil der gemergten
 * People-Liste (features/contacts/ContactsPage.tsx, Rollen-Chip "host");
 * die Host-Anlage haengt dort am Button "+ Add host" (HostFormDrawer).
 * /hosts/:id bleibt vorerst als Host-Detail bestehen.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/hosts/')({
  beforeLoad: () => {
    throw redirect({ to: '/people', replace: true })
  },
  component: () => null,
})
